// import axios from 'axios';
import { Auth } from '@/database';

const state = {
	user: {},
	users: [],
	loggedIn: false,
	usersLoaded: false,
	loadingUsers: false,
	companies: [],
	companiesLoaded: false,
	loadingCompanies: false,
};

const getters = {
	isAuthenticated: state => !!state.user,
	user: state => state.user,
	loggedIn: state => state.loggedIn,
	users: state => state.users,
	companies: state => state.companies,
};

const actions = {
	// async logIn({dispatch}, user) {
	// 	Auth.login(user.username, user.password);
	// 	await dispatch('viewMe');
	// },
	// async loginToken({dispatch}, token) {
	// 	Auth.loginToken(token);
	// 	await dispatch('viewMe');
	// },

	async viewMe({commit, state: {user}}) {
		if (!user.username) {
			const auth = new Auth();
			let user = await auth.whoami();
			await commit('setUser', user);
		}
	},
	async reloadMe({commit}) {
		const auth = new Auth();
		let user = await auth.whoami();
		console.log('Reloaded user:', user);
		await commit('setUser', user);
	},

	async clearUser({commit}) {
		let user = {};
		await commit('setUser', user);
	},

	async getUsers({ commit, state }) {
		if (state.loadingUsers) return; // Prevent multiple simultaneous loads
        if (!state.usersLoaded) {
            commit('setLoadingUsers', true); // Set the loading flag
            try {
				const auth = new Auth();
                const response = await auth.fetch('/users');
				const users = await response.json();
                commit('setUsers', users);
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                commit('setLoadingUsers', false); 
				commit('setUsersLoaded', true); // Mark users as loaded
            }
        }
    },

	async reloadUsers({ commit, state }) {
		commit('setUsersLoaded', false);
		await this.dispatch('getUsers');
	},

	async getCompanies({ commit, state }) {
		if (state.loadingCompanies) return; // Prevent multiple simultaneous loads
		if (!state.companiesLoaded) {
			commit('setLoadingCompanies', true);
			try {
				const auth = new Auth();
				const response = await auth.fetch('/company/list/');
				if (response.ok) {
					const companies = await response.json();
					commit('setCompanies', companies);
				}
			} catch (error) {
				console.error('Error fetching companies:', error);
			} finally {
				commit('setLoadingCompanies', false);
			}
		}
	},


	async updateUser({ commit, state }, userData) {
		try {
			const payload = {
			first_name: userData.first_name ?? state.user?.first_name ?? '',
			last_name: userData.last_name ?? state.user?.last_name ?? '',
			preferred_language: userData.preferred_language ?? userData.language ?? state.user?.preferred_language ?? 'es',
			default_dashboard_id: userData.default_dashboard_id ?? state.user?.default_dashboard_id ?? null,
			};
			const auth = new Auth();
			const response = await auth.fetch(`/users/`, {
			method: 'PUT',
			body: JSON.stringify(payload),
			});

			if (!response.ok) {
			const error = await response.json();
			throw new Error(error.detail || error.message || 'Error al actualizar el usuario');
			}

			const updatedUser = await auth.whoami();
			commit('setUser', updatedUser);
			return updatedUser;
		} catch (error) {
			console.error('Error en updateUser:', error);
			throw error;
		}
		},

	async changePassword({ }, { old_password, new_password }) {
		try {
			const auth = new Auth();
			const response = await auth.fetch('/menu/change_password/', {
				method: 'POST',
				body: JSON.stringify({
				old_password,
				new_password
				})
			});

			if (!response.ok) {
				const error = await response.json().catch(() => ({}));
				throw new Error(error.message || error.detail || 'Error al cambiar la contraseña');
			}

			return await response.json();
		} catch (error) {
		console.error('Error desde Vuex (changePassword):', error.message);
		throw error;
		}
	}


	// async logOut({commit}) {
	// 	let user = null;
	// 	commit('logout', user);
	// },
	
};

const mutations = {
	setUser(state, username) {
		state.user = username;
		state.loggedIn = true;
	},
	setUsers(state, users) {
        state.users = users;
        state.usersLoaded = true;
    },
    setLoadingUsers(state, isLoading) {
        state.loadingUsers = isLoading;
    },
	setUsersLoaded(state, loaded) {
		state.usersLoaded = loaded;
	},
	setCompanies(state, companies) {
		state.companies = companies;
		state.companiesLoaded = true;
	},
	setLoadingCompanies(state, isLoading) {
		state.loadingCompanies = isLoading;
	},
	logout(state, user){
		state.user = user;
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};
